export default "__VITE_PUBLIC_ASSET__152dc375__"